module.exports = __webpack_public_path__ + "img/about-smCN.c918b893.png";